module.exports = {"casino-title":"Notifications","casino-1":"Test"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/fr/user/notifications.lang.json
// module id = scmz
// module chunks = 1